angular.module('zc.zenclerkS')
  .factory('ZcsCampaignName', ZcsCampaignName);

ZcsCampaignName.$inject = ['$translate', 'ZcsSegment'];
function ZcsCampaignName($translate, ZcsSegment) {
  let service = {
    getCampaignName: getCampaignName
  };

  return service;

  function getCampaignName(campaign) {
    let name = '';
    let schedulePart = '';
    let segmentPart = campaign.segment.name;
    let incentivePart = '';

    if(!campaign.segment) {
      segmentPart = '';
    } else if(ZcsSegment.segmentData[campaign.segment.name].label) {
      segmentPart = $translate.instant('services.campaignName.userSegment', { segment: ZcsSegment.segmentData[campaign.segment.name].label });
    }

    // Do not add date part if campaign is saved in middle of creation without
    // date being set
    if(campaign.start_at) {
      schedulePart += `${moment(campaign.start_at).format('MM-DD')}`;

      if(campaign.end_at && moment(campaign.start_at).month() !== moment(campaign.end_at).month()) {
        schedulePart += ` ~ ${moment(campaign.end_at).format('MM-DD')}`;
      }
    }


    if(campaign.incentives[0]) {
      if(campaign.incentives[0].discount_type === 'price') {
        incentivePart = $translate.instant('services.campaignName.off', { amount: `${campaign.currency.symbol}${campaign.incentives[0].discount_price}${campaign.currency.suffix}` });
      } else if(campaign.incentives[0].discount_type === 'percent') {
        incentivePart = $translate.instant('services.campaignName.off', { amount: `${campaign.incentives[0].discount_percent}%` });
      }
    }

    name = `${schedulePart} ${segmentPart} ${incentivePart}`;
    return name;
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/campaign_name.service.js